import React from 'react'
import { useNavigate } from 'react-router-dom'

import { DataTable } from '../../comp/DataTableV2'
import { Traduccion } from '../../comp/Traduccion'

import { setCajaOperada } from '../../config/Sesion'

import { Acceso, NivelAcceso } from '../../utils/Seguridad'
import { Acciones } from '../../utils/Acciones'
import { TipoDato } from '../../utils/Constantes'

import { Detalle, Filtros } from './contenido'
import { abrirCaja, listarCajas } from '../../services/servCajas'
import { Messages } from '../../comp/Messages2'
import { FormatNombreUsuario, FormatPuntoDeVenta } from '../../utils/Formatter'

const vista = 'ViewCajas';
const txtAbierta = Traduccion('TXT_ABIERTA');
const txtCerrada = Traduccion('TXT_CERRADA');

export const Cajas = () => {

    const [tData, setTData] = React.useState([])
    const [filters, setFilters] = React.useState({ user: '', desde: null, hasta: null })
    const [isSearchOpened, setIsSearchOpened] = React.useState(false)
    const [isDetailOpened, setIsDetailOpened] = React.useState(false)
    const [isTableLoading, setIsTableLoading] = React.useState(false)
    const [modalAction, setModalAction] = React.useState(Acciones().SEE)
    const [seleccion, setSeleccion] = React.useState([])
    const [resServicio, setResServicio] = React.useState()

    const navigate = useNavigate()

    const _handleOpenDetail = (action, selection) => {
        var seleccion = selection ? tData.filter(e => e.id === selection) : {};
        if (action === Acciones().SEE) {
            setCajaOperada(seleccion.length > 0 ? seleccion[0] : {});
            navigate('/cajas/movimientos/');
        } else {
            setIsDetailOpened(true)
            setModalAction(action)
            setSeleccion(seleccion)
        }
    }

    const _handleSearchSubmit = (submit, filtros) => {
        setIsSearchOpened(false)
        if (submit) {
            setFilters(filtros)
        }
    }

    const _handleDetailSubmit = (submit) => !submit && setIsDetailOpened(false)

    const formatDataForTable = (datos = []) => {
        datos.forEach(d => {
            d.estado = d.activo ? txtAbierta : txtCerrada
            d.puntoDeVenta.numeroStr = FormatPuntoDeVenta(d.puntoDeVenta)
            d.usuario.nombreYApellidoStr = FormatNombreUsuario(d.usuario)
        })
        return //agregar funcionalidad si hace falta
    }

    React.useEffect(() => {
        setIsTableLoading(true)
        setResServicio()
        listarCajas(filters).then(resListar => {
            formatDataForTable(resListar.data)
            setTData(resListar.data)
            resListar.errores && setResServicio(resListar)
            setIsTableLoading(false)
        })
    }, [filters])

    return <>
        <DataTable title={vista}
            headers={['TXT_CAJERO', 'TXT_PUNTO_DE_VENTA', 'TXT_FECHA_APERTURA', 'TXT_ESTADO']}
            types={[TipoDato.CADENA, TipoDato.NUMERO, TipoDato.FECHA, TipoDato.CADENA]}
            access={['usuario.nombreYApellidoStr', 'puntoDeVenta.numeroStr', 'apertura', 'estado']}
            data={tData}
            rowId="id"
            openSearch={() => setIsSearchOpened(true)}
            openDetail={_handleOpenDetail}
            hasAdd={Acceso(vista, NivelAcceso().AGREGAR)}
            isLoading={isTableLoading}
            showStatusTootip={false} />
        <Filtros values={filters}
            isOpen={isSearchOpened}
            onSubmit={_handleSearchSubmit} />
        <Detalle isOpen={isDetailOpened}
            onSubmit={_handleDetailSubmit}
            seleccion={seleccion[0]} />
        <Messages resServicio={resServicio} accion={modalAction} />
    </>

}